export const environment = {
  production: true,
  socketPrefix: `${window.location.protocol.replace('http', 'ws')}//${window.location.host}/socket`,
  apiPrefix: 'admin-api/v1/',
  about: {version: require('../../package.json').version, buildDate: 1718631111796}
};
